import { queryOptions, useQuery } from "@tanstack/react-query";
import bomBrandService from "../services/bom-brand-service";

export const bomBrandsQueryOptions = () =>
    queryOptions({
        queryKey: ["bom-brands"],
        queryFn: () => bomBrandService.list(),
        staleTime: 1000 * 60 * 60,
    });

export const useBomBrands = () => useQuery(bomBrandsQueryOptions());

export const useBomBrandOptions = () => {
    const query = useBomBrands();
    const options = (query.data ?? []).map((origin) => ({
        value: origin.brand_name,
        label: origin.brand_name,
    }));
    return { ...query, options };
};
